module.exports = __webpack_public_path__ + "static/media/mazda.3a176f83.png";